var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?_c('MobileHeader'):_c('HeaderComponent',{attrs:{"is-scrolled":_vm.isScrolled}}),_c('router-view'),(_vm.isMobile)?_c('MobileFooter'):_c('FooterComponent',{attrs:{"is-scrolled":_vm.isScrolled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }